import { CartItem } from "../utils/interfaces";
import usePosOrderDeliveryMethod from "../atoms/usePosOrderDeliveryMethodAtom";

const usePosMenuGetColor = () => {
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  return (cartItem: CartItem, type: "text" | "bg" = "text") => {
    const firstField =
      type === "bg" ? "back_ground_color_per_target" : "text_color_per_target";

    const secondField = type === "bg" ? "color" : "text_color";

    return cartItem[firstField]
      ? cartItem[firstField]?.[deliveryMethod] ?? cartItem[secondField]
      : cartItem[secondField];
  };
};

export default usePosMenuGetColor;
